var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"bg-variant":"light"}},[_c('h1',[_vm._v("Welcome")]),_c('h2',[_vm._v("Please sign in to continue")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }